import * as React from 'react';
import { Main } from './main';

const PreLoaderComponent = () => {
  return <Main />;
};

export const PreLoader = React.memo(PreLoaderComponent);
